<template>
    <form @submit.prevent="profileSettingsUpdate">
        <div class="shadow sm:rounded-md sm:overflow-hidden">
            <!-- <Link class="block py-2.5 px-4 text-sm w-1/4 bg-red-50" :href="route('profile')"> -->
            <Link
                :href="route('profile')"
                class="lg:mt-6 mx-4 flex lg:justify-between lg:w-1/5 w-1/2 gap-2 text-blue-600 items-center hover:scale-105 duration-150 py-2 rounded-md"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    class="w-6 h-6 flex-shrink-0"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                    />
                </svg>

                <p class="tracking-wider text-sm">Back to profile</p>
            </Link>
            <!-- </Link> -->
            <div class="bg-white py-6 px-4 space-y-6 sm:p-6">
                <div class="flex items-center">
                    <div class="relative w-[80px] h-[80px] border rounded-full">
                        <div for="profile-pic" class="absolute -left-2.5">
                            <label
                                for="file-upload"
                                class="relative cursor-pointer bg-white rounded-md"
                            >
                                <div
                                    class="relative hover:bg-gray-100 cursor-pointer bg-white w-[30px] h-[30px] p-3 border border-blue-500 rounded-full"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        class="absolute top-1.5 right-1 w-5 h-3.5"
                                    >
                                        <path
                                            d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32L19.513 8.2z"
                                        />
                                    </svg>
                                </div>
                                <input
                                    id="file-upload"
                                    name="file-upload"
                                    type="file"
                                    class="sr-only"
                                    accept="image/png, image/jpeg"
                                    @change="onProfileImageChange"
                                    @input="
                                        form.profile_pic =
                                            $event.target.files[0]
                                    "
                                />
                            </label>
                        </div>

                        <div
                            class="w-[80px] h-[80px] rounded-full overflow-hidden"
                        >
                            <img
                                v-if="profileUrl"
                                :src="profileUrl"
                                :alt="user.name"
                                class="object-contain"
                            />
                            <img
                                v-if="!profileUrl && user.profile_pic"
                                :src="'/storage/' + user.profile_pic"
                                :alt="user.name"
                                class="object-contain"
                            />
                            <img
                                v-else
                                class="object-contain p-4"
                                src="https://cdn-icons-png.flaticon.com/512/6643/6643418.png"
                                alt=""
                            />
                        </div>
                    </div>
                    <div
                        class="text-xs text-red-500 mt-1 tracking-wide"
                        v-if="form.errors.profile_pic"
                        v-text="form.errors.profile_pic"
                    ></div>

                    <div class="px-4">
                        <h3 class="text-lg leading-6 font-medium text-gray-900">
                            Profile
                        </h3>
                        <p class="mt-1 text-sm text-gray-500">
                            This information will be used when you apply to
                            jobs.
                        </p>
                    </div>
                </div>

                <div class="grid grid-cols-6 gap-6">
                    <div class="col-span-6">
                        <label
                            for="name"
                            class="block text-sm font-medium text-gray-700"
                            >Name</label
                        >
                        <input
                            v-model="form.name"
                            type="text"
                            name="name"
                            id="name"
                            autocomplete="name"
                            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm disabled: bg-gray-100"
                            disabled
                        />
                        <div
                            class="text-xs text-red-500 mt-1 tracking-wide"
                            v-if="form.errors.name"
                            v-text="form.errors.name"
                        ></div>
                    </div>

                    <div class="col-span-6 sm:col-span-3">
                        <label
                            for="email-address"
                            class="block text-sm font-medium text-gray-700"
                            >Email address</label
                        >
                        <input
                            v-model="form.email"
                            type="text"
                            name="email-address"
                            id="email-address"
                            autocomplete="email"
                            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm disabled:bg-gray-100"
                            disabled
                        />
                        <div
                            class="text-xs text-red-500 mt-1 tracking-wide"
                            v-if="form.errors.email"
                            v-text="form.errors.email"
                        ></div>
                    </div>

                    <!-- <div class="col-span-6 sm:col-span-3">
            <label for="country" class="block text-sm font-medium text-gray-700"
              >Country / Region</label
            >
            <select
              id="country"
              name="country"
              autocomplete="country"
              class="
                mt-1
                block
                w-full
                bg-white
                border border-gray-300
                rounded-md
                shadow-sm
                py-2
                px-3
                focus:outline-none focus:ring-blue-500 focus:border-blue-500
                sm:text-sm
              "
            >
              <option>United States</option>
              <option>Canada</option>
              <option>Mexico</option>
            </select>
          </div> -->

                    <div class="col-span-6 md:col-span-3">
                        <label
                            for="phone-number"
                            class="block text-sm font-medium text-gray-700"
                            >Phone number</label
                        >
                        <input
                            v-model="form.phone_number"
                            type="text"
                            name="phone-number"
                            id="phone-number"
                            autocomplete="phone-number"
                            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        />
                        <div
                            class="text-xs text-red-500 mt-1 tracking-wide"
                            v-if="form.errors.phone_number"
                            v-text="form.errors.phone_number"
                        ></div>
                    </div>

                    <div class="col-span-6 md:col-span-3">
                        <label
                            for="city"
                            class="block text-sm font-medium text-gray-700"
                            >City</label
                        >
                        <input
                            v-model="form.city"
                            type="text"
                            name="city"
                            id="city"
                            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        />
                        <div
                            class="text-xs text-red-500 mt-1 tracking-wide"
                            v-if="form.errors.city"
                            v-text="form.errors.city"
                        ></div>
                    </div>

                    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                        <label
                            for="state"
                            class="block text-sm font-medium text-gray-700"
                            >State / Province</label
                        >
                        <input
                            v-model="form.state"
                            type="text"
                            name="state"
                            id="state"
                            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        />
                        <div
                            class="text-xs text-red-500 mt-1 tracking-wide"
                            v-if="form.errors.state"
                            v-text="form.errors.state"
                        ></div>
                    </div>

                    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                        <label
                            for="zip-code"
                            class="block text-sm font-medium text-gray-700"
                            >ZIP / Postal</label
                        >
                        <input
                            v-model="form.zipcode"
                            type="text"
                            name="zip-code"
                            id="zip-code"
                            autocomplete="zip-code"
                            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        />
                        <div
                            class="text-xs text-red-500 mt-1 tracking-wide"
                            v-if="form.errors.zipcode"
                            v-text="form.errors.zipcode"
                        ></div>
                    </div>
                </div>

                <!-- <div class="grid grid-cols-3 gap-6">
          <div class="col-span-3">
            <label for="bio" class="block text-sm font-medium text-gray-700">
              Bio
            </label>
            <div class="mt-1">
              <textarea
                id="bio"
                name="bio"
                rows="3"
                class="shadow-sm focus:ring-blue-500 focus:border-blue-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                placeholder="Tell us about yourself"
              />
            </div>
            <p class="mt-2 text-sm text-gray-500">
              Brief description for your profile.
            </p>
          </div>

          <div class="col-span-3">
            <label class="block text-sm font-medium text-gray-700">
              Photo
            </label>
            <div class="mt-1 flex items-center">
              <span
                class="inline-block bg-gray-100 rounded-full overflow-hidden h-12 w-12"
              >
                <svg
                  class="h-full w-full text-gray-300"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"
                  />
                </svg>
              </span>
              <button
                type="button"
                class="ml-5 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Change
              </button>
            </div>
          </div>

          <div class="col-span-3">
            <label class="block text-sm font-medium text-gray-700">
              Cover photo
            </label>
            <div
              class="mt-1 border-2 border-gray-300 border-dashed rounded-md px-6 pt-5 pb-6 flex justify-center"
            >
              <div class="space-y-1 text-center">
                <svg
                  class="mx-auto h-12 w-12 text-gray-400"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 48 48"
                  aria-hidden="true"
                >
                  <path
                    d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <div class="flex text-sm text-gray-600">
                  <label
                    for="file-upload"
                    class="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500"
                  >
                    <span>Upload a file</span>
                    <input
                      id="file-upload"
                      name="file-upload"
                      type="file"
                      class="sr-only"
                    />
                  </label>
                  <p class="pl-1">or drag and drop</p>
                </div>
                <p class="text-xs text-gray-500">PNG, JPG, GIF up to 10MB</p>
              </div>
            </div>
          </div>
        </div> -->
            </div>
            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                <button
                    type="submit"
                    class="bg-blue-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                    Save
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import { Link, useForm } from "@inertiajs/inertia-vue3";
import { ref } from "@vue/reactivity";

export default {
    props: {
        user: Object,
    },
    setup(props) {
        const { user } = props;
        let profileUrl = ref(null);

        const form = useForm({
            name: user.name,
            email: user.email,
            phone_number: user.phone_number,
            city: user.city,
            state: user.state,
            zipcode: user.zipcode,
            phone_number: user.phone_number,
            profile_pic: user.profile_pic,
        });

        const route = window.route;
        const profileSettingsUpdate = async () => {
            if (!profileUrl.value) {
                delete form.profile_pic;
            }
            form.post(route("profile.settings.update"));
        };

        function onProfileImageChange(e) {
            const file = e.target.files[0];
            profileUrl.value = URL.createObjectURL(file);
            // console.log(profileUrl);
        }

        return {
            form,
            route,
            profileSettingsUpdate,
            onProfileImageChange,
            profileUrl,
        };
    },

    components: {
        Link,
    },
};
</script>
